import type { BulletinDetails } from 'api/v1/requests/bulletins';
import {
  formatBulletinSubjectTitle,
  translatePlannedDuration,
  translateStudyLocations,
  formatBulletinSchedule,
} from 'utils/bulletinLabels';

const formatPrice = (from?: number, to?: number): string => {
  if (from == null && to == null) return '';
  if (from != null && to != null && from !== to) {
    return `${from.toLocaleString('ru-RU')}-${to.toLocaleString('ru-RU')} руб./час`;
  }
  const value = from ?? to;
  return value != null ? `${value.toLocaleString('ru-RU')} руб./час` : '';
};

export const formatBulletinSummary = (bulletin: BulletinDetails): string => {
  const parts: string[] = [];

  if (bulletin.student_name) {
    parts.push(bulletin.student_name);
  }

  if (bulletin.grade != null) {
    parts.push(`${bulletin.grade} класс`);
  }

  const duration = translatePlannedDuration(bulletin.planned_duration);
  if (duration) {
    parts.push(`Длительность: ${duration}`);
  }

  const subject = formatBulletinSubjectTitle(bulletin.subject_category);
  if (subject) {
    parts.push(subject);
  }

  const locations = translateStudyLocations(bulletin.study_locations);
  parts.push(locations || 'Онлайн');

  const schedule = formatBulletinSchedule(bulletin);
  if (schedule) {
    parts.push(`Удобно: ${schedule.charAt(0).toLowerCase()}${schedule.slice(1)}`);
  }

  const price = formatPrice(bulletin.price_from, bulletin.price_to);
  if (price) {
    parts.push(price);
  }

  return parts.filter(Boolean).join(', ');
};
